import { ArchiveMutation } from "../../../../hooks/useArchiveState";
import { PriorAuthorizationControllerApi } from "../../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useAuthorizationArchive = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new PriorAuthorizationControllerApi(
      getConfigObject()
    ).updatePriorAuthorizationArchiveStatus(
      param.id,
      param.status,
      getXtenantId()
    )
  );
